export const POS_CONFIG = {
    // POS Configuration for All/SFA-Delivery
    ALL: {
        terminal: 'DESKTOP-GHUBBNV',
        terminalGroup: 'SFA-Delivery',
        organizationId: 'cef12ab2-d9a5-4e3f-babb-11e6254849e8',
        terminalGroupId: '826d527c-bc55-495c-9ce2-43369609512e',
        section: 'SFA-DELIVERY',
        cashRegister: '1FCR',
        orderTypes: {
            delivery: 'delivery',
            pickup: 'pickup',
            table: 'table'
        }
    },

    // Individual restaurant configurations can be added here
    COPACABANA: {
        // organizationId should come from /organizations API (GUID), not hardcoded
        terminalGroup: 'CopaCabana'
    },
    AROMIITALIANI: {
        // organizationId should come from /organizations API (GUID), not hardcoded
        terminalGroup: 'AromiItaliani'
    },
    SYMPOSIUM: {
        // organizationId should come from /organizations API (GUID), not hardcoded
        terminalGroup: 'Symposium'
    },
    POSHNOSH: {
        // organizationId should come from /organizations API (GUID), not hardcoded
        terminalGroup: 'PoshNosh'
    },
    NADIMI: {
        // organizationId should come from /organizations API (GUID), not hardcoded
        terminalGroup: 'Nadimi'
    }
};

export const getPOSConfig = (restaurant) => {
    if (restaurant === 'All') {
        return POS_CONFIG.ALL;
    }

    const aliases = {
        POSHNOSHS: 'POSHNOSH'
    };
    const restaurantUpper = restaurant?.toUpperCase().replace(/\s+/g, '');
    const configKey = aliases[restaurantUpper] || restaurantUpper;
    return POS_CONFIG[configKey] || POS_CONFIG.ALL;
};

// Helper function to find and log organization and terminal group IDs
export const findAllPOSIds = async (token, apiProxyBase) => {
    try {
        // Get all organizations
        const orgRes = await fetch(`${apiProxyBase}/organizations`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                organizationIds: [],
                returnAdditionsInfo: true,
                includeDisabled: false,
            }),
        });
        const orgData = await orgRes.json();
        const allOrganizations = orgData.organizations;

        console.log('\n=== Available Organizations ===');

        for (const org of allOrganizations) {
            console.log(`\nOrganization: ${org.name}`);
            console.log(`  ID: ${org.id}`);

            // Get terminal groups for this organization
            const terminalRes = await fetch(`${apiProxyBase}/terminalgroups`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ organizationIds: [org.id] }),
            });
            const terminalData = await terminalRes.json();
            const terminalGroups = terminalData?.terminalGroups?.[0]?.items || [];

            console.log('  Terminal Groups:');
            terminalGroups.forEach(tg => {
                console.log(`    - ${tg.name}: ${tg.id}`);
                if (tg.name === 'SFA-Delivery') {
                    console.log(`\n⭐ FOUND SFA-Delivery!`);
                    console.log(`   Add these to posConfig.js ALL section:`);
                    console.log(`   organizationId: '${org.id}',`);
                    console.log(`   terminalGroupId: '${tg.id}',\n`);
                }
            });
        }
    } catch (error) {
        console.error('Error finding POS IDs:', error);
    }
};
